import { mapFeatureCalloutUtils } from './mapFeatureCalloutUtils.js';
import { hasNonLocationFilters } from '../common/searchRequestUtils.js';

/**
 * The key under which we'll record "when did we last surprise-send this user to map-search?" in localstorage.
 * @type {string}
 */
const LOCALSTORAGE_KEY = 'lastSentToMap';

/**
 * True if this search-URL contains at least one "location" search parameter and no non-"location" search parameters.
 */
const isLocationSearch = (searchUrl) => {
    const hasFilters = new Uri(searchUrl).queryPairs.length > 0;
    return hasFilters && !hasNonLocationFilters(searchUrl);
};

// Time to wait before sending the user back to the map.
const DELAY_IN_MS = 30 * 60 * 1000; // 30 minutes

const wasRecentlySentToMap = () => {
    const epochString = localStorage.getItem(LOCALSTORAGE_KEY);
    if (epochString === null) {
        return false;
    }

    const msSinceLastSentToMap = new Date().getTime() - parseInt(epochString);
    return msSinceLastSentToMap < DELAY_IN_MS;
};

export const shouldSendSearchToMap = (searchUrl, context) => {
    // Don't send if flag says not to
    if (!context.isSendLocationSearchToMapEnabled) {
        return false;
    }

    // Don't send if this isn't a location-search
    if (!isLocationSearch(searchUrl)) {
        return false;
    }

    return !wasRecentlySentToMap();
};
const getMapUrlFor = (searchUrl) => {
    return mapFeatureCalloutUtils.getMapFeatureUrl(searchUrl);
};
/**
 * Note: assumes you've already updated browser-history with pushState before calling.
 */
export const sendToMap = (searchUrl) => {
    const newUrl = getMapUrlFor(searchUrl);
    localStorage.setItem(LOCALSTORAGE_KEY, new Date().getTime());

    window.location = newUrl;
};
